import React from 'react';

const pricingPlans = [
  {
    name: 'Wedding Highlight',
    price: '$105 USD',
    icon: '◆',
    features: [
      'Edited to Match Your Style',
      '3–5 Minute Highlight',
      'Colour Correction Included (If Needed)',
      'Zero Risk Trial',
      'Fast 3-5 Day Turnaround',
      'Unlimited Changes Included',
      'No Hidden Charges',
      'Pay After Approval',
      'Variations on the above are welcome'
    ],
    popular: false
  },
  {
    name: 'Wedding Feature',
    price: '$115 USD',
    icon: '◆',
    features: [
      'Edited to Match Your Style',
      'Feature Duration: Up to 90 Minutes',
      'Colour Correction Included (If Needed)',
      'Zero Risk Trial',
      'Fast 3-5 Day Turnaround',
      'Unlimited Changes Included',
      'No Hidden Charges',
      'Pay After Approval',
      'Variations on the above are welcome'
    ],
    popular: false
  },
  {
    name: 'Wedding Highlight & Feature',
    price: '$175 USD',
    icon: '◆',
    features: [
      'Edited to Match Your Style',
      '3–5 Minute Highlight',
      'Feature Duration: Up to 90 Minutes',
      'Colour Correction Included (If Needed)',
      'Zero Risk Trial',
      'Fast 5-7 Day Turnaround',
      'Unlimited Changes Included',
      'No Hidden Charges',
      'Pay After Approval',
      'Variations on the above are welcome'
    ],
    popular: true
  }
];

const Services = () => {
  return (
    <div id="services">
      <div className="container">
        <div className="sixteen columns">
          <div className="section-top">
            <div className="line-dark"></div>
            <h1>services</h1>
            <div className="subtext-top">Simplicity, attention to detail...</div>
            <div className="line-dark1"></div>
          </div>
        </div>
      </div>
      
      <div className="container">
        <div className="sixteen columns">
          <div className="separ"></div>
        </div>
        <div className="sixteen columns">
          <div className="subsection-top">
            <div className="subline-dark"></div>
            <h3>Efficient Affordable Pricing Packages</h3>
            <div className="subline-dark1"></div>
          </div>
        </div>
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '40px',
        padding: '60px 20px',
        flexWrap: 'wrap',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {pricingPlans.map((plan, index) => (
          <div
            key={index}
            style={{
              position: 'relative',
              flex: '1',
              minWidth: '280px',
              maxWidth: '340px',
              background: '#fff',
              border: plan.popular ? '2px solid #d4af37' : '1px solid #e8e8e8',
              padding: '50px 40px',
              textAlign: 'center',
              transition: 'all 0.4s ease',
              boxShadow: plan.popular ? '0 8px 30px rgba(212, 175, 55, 0.15)' : '0 4px 20px rgba(0,0,0,0.08)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = plan.popular 
                ? '0 8px 30px rgba(212, 175, 55, 0.15)' 
                : '0 4px 20px rgba(0,0,0,0.08)';
            }}
          >
            {plan.popular && (
              <div style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                color: '#d4af37',
                fontSize: '11px',
                fontWeight: '500',
                letterSpacing: '2px',
                textTransform: 'uppercase'
              }}>
                Popular
              </div>
            )}

            <div style={{
              fontSize: '24px',
              color: '#d4af37',
              marginBottom: '20px',
              letterSpacing: '4px'
            }}>
              {plan.icon} {plan.icon} {plan.icon}
            </div>

            <div style={{
              fontSize: '42px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '8px',
              letterSpacing: '1px'
            }}>
              {plan.price.replace(' USD', '')}
              <span style={{
                fontSize: '18px',
                fontWeight: '400',
                marginLeft: '8px',
                color: '#666'
              }}>USD</span>
            </div>

            <div style={{
              fontSize: '11px',
              color: '#999',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              marginBottom: '10px',
              fontWeight: '500'
            }}>
              {plan.name}
            </div>

            <div style={{
              width: '40px',
              height: '1px',
              background: '#d4af37',
              margin: '30px auto'
            }}></div>

            <div style={{
              marginBottom: '40px'
            }}>
              {plan.features.map((feature, i) => (
                <p key={i} style={{
                  fontSize: '12px',
                  color: feature.includes('BONUS') ? '#d4af37' : '#666',
                  letterSpacing: '0.5px',
                  lineHeight: '2',
                  margin: 0,
                  fontWeight: feature.includes('BONUS') || feature.includes('Unlimited') || feature.includes('Zero-Risk') ? '700' : '400'
                }}>
                  {feature}
                </p>
              ))}
            </div>

            <button
              onClick={() => {
                // Scroll to project registration form
                const projectSection = document.getElementById('project-registration');
                if (projectSection) {
                  projectSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              style={{
                width: '100%',
                padding: '14px 30px',
                border: plan.popular ? '2px solid #d4af37' : '2px solid #333',
                background: plan.popular ? '#d4af37' : '#333',
                color: '#fff',
                fontSize: '11px',
                fontWeight: '500',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = plan.popular ? '#d4af37' : '#333';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = plan.popular ? '#d4af37' : '#333';
                e.currentTarget.style.color = '#fff';
              }}
            >
              Select Plan
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
